<template>
  <v-container style="height:100%;transition:1.2s;background:white;">
    <v-row class="text-center" style="height: 100%;">
      <v-card
      class="mx-auto"
      style="position: relative;height:25vh;width:100%;margin-bottom: 0; background-image: url(./images/ui/bg.png);background-size: cover;border:0px;"
      outlined
    >
      
  
    </v-card>
      <div style="display: flex;justify-content: center;align-items: flex-end;position: relative;margin-top: auto;width:100%;height:20px;background:white;border-radius: 0px;">
        <img style="height: 10px;width: 75vw;border:0px;margin:0px;" src="/images/ui/top.png">
        <div ref="ani_card" id="ani_card" style="background-image: url('./images/ui/card.png');">
          <h4 style="position: absolute;top: 1px;left: 0;right: 0;color:white;">GPS打卡</h4>
          <div class="col-10 d-flex mt-4" style="margin: 0 auto;">
            <div class="col-5">
              <v-img
                max-height="70"
                max-width="70"
                v-bind:src="User.pictureUrl"
              ></v-img>
            </div>
            <div class="col-7 text-left">
              <h1 class="fz-11 ">您好!</h1>
              <h4 class="fz-18" style="color: black;">{{ User.displayName }}</h4>
            </div>
          </div>
        </div>
      </div>
      <v-card
        class="mx-auto"
        style="position: relative;height:70vh;width:100%;margin-bottom: 0;border-radius: 0px;z-index: 10;border:0px;"
        outlined
      >
      <div style="max-height: 5vh; min-height: 5vh;background-image: url(./images/ui/bottom.png);background-position: top;background-size:75vw;">
        <!-- <img style="width: 60%;" src="/images/ui/bottom.png"> -->
      </div>
      <div
          style="width: 100vw;display:flex;justify-content: center;"
      >
          <h4 class="fz-25 circle">{{ time.HH }}:{{ time.MM }}:{{time.SS}}</h4>
      </div>
      <v-list-item three-line style="border: 0px;">
        <v-list-item-content>
          <v-list-item-subtitle  class="fz-11">{{ hellomsg }}</v-list-item-subtitle>
          <v-list-item-subtitle class="fz-13 font-bold" v-show="canTouch"><div ref="info" v-html="ls_status" style="min-height:70px; max-height:70px;overflow:auto;"></div></v-list-item-subtitle>  
        </v-list-item-content>
      </v-list-item>
      <div
          style="width: 90vw;margin:auto auto;display:flex;justify-content: space-around;"
      >
        <v-btn :dark= "btnOn.dark" color="#e25958" @click="takeOn" :disabled="btnOn.disabled" x-large style="width: 42vw;height: 42vw;border-radius:10%;">
          <div>
          <h1 class="fz-25 mb-4" v-html="btnOn.checkMsg"></h1>
          <h4 v-if="btnOn.checkTime!=''" class="fz-11">{{ btnOn.checkTime }}</h4>
          </div>
        </v-btn>
        <v-btn :dark= "btnOff.dark" color="#75c7c5" @click="takeOff" :disabled="btnOff.disabled" x-large style="width: 42vw;height: 42vw;border-radius: 10%;">
          <div>
            <h1 class="fz-25 mb-4" v-html="btnOff.checkMsg"></h1>
            <h4 v-if="btnOff.checkTime!=''" class="fz-11">{{ btnOff.checkTime }}</h4>
          </div>
        </v-btn>
      </div>
      </v-card>
     
    </v-row>
  </v-container>
</template>

<script>
  import axios from 'axios';
  export default {
    name: 'App',
    props: ['baseURL','baseLINE','baseAPI','baseADMIN','tax'],
    data: () => ({
      NowDate:new Date(),
      time:{
        HH:"00",
        MM:"00",
        SS:"00"
      },
      hello:"",
      hellomsg:"",
      canTouch:false,
      haveRecord:false,
      punchShift:null,
      punchType:null,
      msg:"",
      User:{},
      UserfId:null,
      groupColor:"#1976D2",
      groupName:"",
      ls_status:"",
      ls_allshift:null,
      ls_allovertime:null,
      bgColor:"linear-gradient(to top, #30cfd0 0%, #330867 100%)",
      textColor:"#768591",
      timeShadow:"text-shadow",
      attr_color:'#768591',
      attr_loading:false,
      attr_dark:true,
      attr_disable:false,
      attr_icon:"mdi-clock-time-eight-outline",
      anIcon:true,
      anLoading:false,
      anCheck:false,
      position:null,
      ary_position:[],
      watchID:null,
      shiftfId:7,
      btnOn:{
        get dark(){
          let blooen = true;
          if(this.disabled == true){
            blooen = false;
          }
          return blooen
        },
        checkMsg:"上班",
        checkTime:"",
        color:"gray",
        disabled:true,
      },
      btnOff:{
        get dark(){
          let blooen = true;
          if(this.disabled == true){
            blooen = false;
          }
          return blooen
        },
        checkMsg:"下班",
        checkTime:"",
        color:"gray",
        disabled:true,
      }
      
    }),
    mounted() {
      this.$store.commit('SET_LAYOUT', "simple-layout")
      this.$emit("menuShow",false);
      let query = this.$route.query;
      this.str_userid = localStorage.getItem("Userid");
      this.str_groupid = localStorage.getItem("Groupid");
      this.groupName = query['GroupName'];
      this.chkGeo();
      this.getConvert();
      this.getInfo();
      this.InterShow();
    },
    
    methods:{
      chkGeo(){
        if (!navigator.geolocation) {
         
          this.play_info("請開啟手機定位服務")
        }
      },
      loading(){
        this.anLoading = true;
        this.anCheck = false;
      },
      testOK(){
        this.anLoading = true;
        this.anCheck = false;
        this.play_info("檢測打卡環境")
        setTimeout(() => {
          let str_time = this.time.HH+":"+this.time.MM+":"+this.time.SS;
          this.play_info("打卡成功")
          this.anLoading = false;
          this.anCheck = true;
          this.btnOn.checkMsg="上班"+str_time;
          this.btnOn.checkTime = str_time;
          this.btnOn.color="green";
        }, 2000);
        
      },
      testNo(){
        this.anLoading = true;
        this.anCheck = false;
        this.play_info("檢測打卡環境")
        setTimeout(() => {
          this.play_info("打卡失敗")
          this.anLoading = false;
          this.btnOn.checkMsg="重新打卡";
          this.btnOn.checkTime = "";
          this.btnOn.color="red";
        }, 2000);
        
      },
      addz:function(num){
        return num<10?'0'+num:num;
      },
      getSmallTime(hh,mm,proc) {
            var date = new Date(0,0,0,hh,mm,0,0);
            date.setMinutes(date.getMinutes()+proc);
            return date;
      },
      ShowTime:function(){
        this.NowDate=new Date("2021-10-3");
        // this.time.HH = this.addz(this.NowDate.getHours());
        // this.time.MM = this.addz(this.NowDate.getMinutes());
        // this.time.SS = this.addz(this.NowDate.getSeconds());
        this.time.HH = "13";
        this.time.MM = "01";
        this.time.SS = "04";

        let nWeek = this.NowDate.getDay();
        if(nWeek == 0 ){
          nWeek = 7
        }
        let ntTime = this.getSmallTime(this.time.HH,this.time.MM,0).getTime();
        let nope = true;
        console.log("所有班表",this.ls_allshift)
        if(this.ls_allshift!=null){
          let shift = Object.values(this.ls_allshift).filter(d => d.fWeek === nWeek && ntTime>=this.getSmallTime(d.f上班起始hours,d.f上班起始minute,0-d.f上班前打卡).getTime() && ntTime<=this.getSmallTime(d.f上班結束hours,d.f上班結束minute,d.f上班結束後打卡+d.f加班+d.f加班結束後打卡).getTime());
          if(shift.length!=0){
            this.punchType = "NORMAL"
            this.hellomsg = "當前班表:"+ shift[0].f班表Name;
            this.canTouch = true;
            this.punchShift = shift[0];
            if(this.haveRecord == false){
              this.getRecord();
            }
            nope = false;
          }
        }
        if(this.ls_allovertime!=null && Object.keys(this.ls_allovertime).length!=0){
          // console.log(ntTime,this.ls_allovertime,Object.keys(this.ls_allovertime).length);
          let stime = this.ls_allovertime[0].f加班開始.split("T");
          let etime = this.ls_allovertime[0].f加班結束.split("T");
          var rightNow = new Date();
          var res = rightNow.toISOString().slice(0,10);

          let obj = {stime:stime[1].split(":"),etime:etime[1].split(":"),f加班前打卡:this.ls_allovertime[0].f加班前打卡,f加班結束後打卡:this.ls_allovertime[0].f加班結束後打卡}
          let _s = this.getSmallTime(obj.stime[0],obj.stime[1],obj.f加班前打卡).getTime()
          let _e = this.getSmallTime(obj.etime[0],obj.etime[1],obj.f加班結束後打卡).getTime()
          if( res == stime[0] && ntTime >= _s && ntTime<=_e){
            this.punchType = "OVERTIME"
            this.hellomsg = "當前為加班時段";
            this.canTouch = true;
            this.punchShift = this.ls_allovertime[0];
            if(this.haveRecord == false){
              this.getRecord();
            }
            nope = false;
          }
          //let overtime = Object.values(this.ls_allovertime).filter();    
        }
        if(nope == true){
          this.hellomsg = "當前非上班時段";
          this.btnOn.disabled = true;
          this.btnOff.disabled = true;
          this.punchShift = null
          this.canTouch = false;
        }
        
      },
      InterShow:function(){
        this.Timer = setInterval(() => {
          this.ShowTime();
        }, 1000);
      },
      play_info(text){
        this.ls_status+="<p class='mb-4 mt-7'>"+ text +"</p>"
        setTimeout(() => {
            this.$refs.info.scrollTo({
              top: this.$refs.info.scrollHeight,
              left: 0,
              behavior: 'smooth'
            });
        }, 20);
      },
      play_circle(text,bg,cor){
        this.ls_status+="<p class='mb-4 mt-7 text-circle' style='background-color:"+ bg +";color:"+ cor +";'>"+ text +"</p>"
        setTimeout(() => {
            this.$refs.info.scrollTo({
              top: this.$refs.info.scrollHeight,
              left: 0,
              behavior: 'smooth'
            });
        }, 20);
      },
      takeOn(){
        let self = this;
        this.anIcon = false;
        this.anLoading = true;
        this.anCheck = false;
        this.play_info("檢測打卡環境");
        this.$refs.ani_card.classList.toggle("a-ctive");
        // this.fnPunch(()=>{//success
        //   ////console.log("取得位置",self.position);
        //   self.sendCard("Punch_in_work",self.btnOn,"上班");
        // },()=>{//fail
        //   //self.play_info("定位服務發生錯誤");
        // });
        self.btnOn.disabled = true;
        self.btnOff.disabled = true;
        navigator.geolocation.getCurrentPosition(function(position) {
          self.play_info("取得當前ip位置")
          let lat = position.coords.latitude;
          let long = position.coords.longitude;
          self.position = {lat:lat,lng:long};
          self.sendCard("Punch_in_work",self.btnOn,"上班");
        },()=>{
          this.play_info("定位服務發生錯誤")
        });
      },
      takeOff(){
        let self = this;
        this.anIcon = false;
        this.anLoading = true;
        this.anCheck = false;
        this.play_info("檢測打卡環境")
        this.$refs.ani_card.classList.toggle("a-ctive");
        // this.fnPunch(()=>{//success
        //   ////console.log("取得位置",self.position);
        //   self.sendCard("Punch_out_work",self.btnOff,"下班");
        // },()=>{//fail
        //   //self.play_info("定位服務發生錯誤");
        // });
        self.btnOn.disabled = true;
        self.btnOff.disabled = true;
        navigator.geolocation.getCurrentPosition(function(position) {
          self.play_info("取得當前ip位置")
          let lat = position.coords.latitude;
          let long = position.coords.longitude;
          self.position = {lat:lat,lng:long};
          
          self.sendCard("Punch_out_work",self.btnOff,"下班");
        },()=>{
          this.play_info("定位服務發生錯誤")
        });
      },

      fnPunch(success,fail){
        let self = this;
        this.ary_position = [];
        self.play_info("取得當前GPS位置")
        this.btnOff.disabled = true;
        this.btnOn.disabled = true;
        this.$refs.ani_card.classList.toggle("a-ctive");
        this.watchID = navigator.geolocation.watchPosition((position)=>{
          let lat = position.coords.latitude;
          let long = position.coords.longitude;
          this.ary_position.push({lat:lat,lng:long});
          if(this.ary_position.length==2){
            navigator.geolocation.clearWatch(self.watchID);
            self.watchID = null;
            self.position = self.ary_position[self.ary_position.length-1];
            //console.log("位置資訊",self.ary_position[self.ary_position.length-1],self.position)
            success();
          }else{
            fail();
          }
        });
        // setTimeout(() => {
         
        //   if(self.ary_position.length!=0){
        //     self.position = self.ary_position[self.ary_position.length-1];
        //     //console.log("位置資訊",self.ary_position[self.ary_position.length-1],self.position)
        //     success();
        //   }else{
        //     fail();
        //   }
          
          
        // }, 1500);

      },
      
      getConvert(){
        //https://testpunchinweb.pokerfun.com.tw/api/Punch/LineIdConvertToMid?Lineid=Uef96d9a7c2455fc5d51ae714c160e3e5
        try{
            //console.log(this.str_userid,"hello",this.baseURL+'/api/Punch/LineIdConvertToMid?Lineid='+ this.str_userid)
            axios
            .get(this.baseURL+'/api/Punch/LineIdConvertToMid?Lineid='+ this.str_userid)
            .then((response) => {
              //console.log("hello",response);
              let data = JSON.parse(response.data);
              this.UserfId = data[0].fId;
              this.getAllShift();
              this.getAllOverTime();
              // this.User = data;
              // this.play_info("您好! "+this.User.displayName+"<br/>按下按鈕開始打卡");
  
            })
            .catch(function (error) { // 请求失败处理
              console.log(error);
            });
        }catch(e){
          this.msg = e;
        }
      },
      sendCard(event,who,when){
        if(this.punchShift==null){
          return;
        }
        let url = this.baseURL+'/api/Punch/'+ event +'?str_GroupId='+ this.str_groupid +'&dou_Longitude='+ this.position.lng +'&dou_Latitude='+ this.position.lat +'&strUserLineID='+this.str_userid+'&shiftfId='+this.punchShift.fId;
        if(this.punchType == "OVERTIME"){
          url = this.baseURL+'/api/OverTimePunch/'+ event +'?str_GroupId='+ this.str_groupid +'&dou_Longitude='+ this.position.lng +'&dou_Latitude='+ this.position.lat +'&strUserLineID='+this.str_userid+'&shiftfId='+this.punchShift.fId;
        }
        // let str_time = this.time.HH+":"+this.time.MM+":"+this.time.SS;
        this.play_info("正在傳送打卡資訊...")
        //console.log(this.position);
        try{
            axios
            .get(url)
            //.get(this.baseURL+'/api/Punch/'+ event +'?str_GroupId=C8db7d24d5ed86c00722ffd9441a8ce6d&dou_Longitude=120.3070829&dou_Latitude=22.6576568&strUserLineID=Uef96d9a7c2455fc5d51ae714c160e3e5&shiftfId='+this.shiftfId)
            .then((response) => {
              let data = JSON.parse(response.data);
              console.log(data,when)
              who.disabled = false;
              this.$refs.ani_card.classList.toggle("a-ctive");
              if(data.loc == "error"){
                  this.play_circle("打卡失敗 <br/>原因:沒有在可打卡範圍內","#e25958","white");
                  //this.play_info("打卡失敗 <br/>原因:沒有在可打卡範圍內")
                  this.anLoading = false;
                  who.checkMsg="重新<br/>打卡";
                  who.checkTime = "";
                  who.color="red";
                  who.disabled = false;
              }else{
                  switch(data.status){
                    case"無效":
                      // this.play_info("打卡無效 <br/>原因:沒有匹配的班表")
                      // this.anLoading = false;
                      // this.anCheck = true;
                      // who.checkMsg="非"+ when +"打卡時段";
                      // who.color="orange";
                      
                      // this.getRecord();
                      this.play_circle("打卡無效 提醒:上班卡未打","#808080","white");
                      //this.play_info("打卡無效 提醒:上班卡未打")
                      this.anLoading = false;
                      this.anCheck = true;
                      //who.checkMsg=when+str_time;
                      //who.color="green";
                      this.getRecord();
                    break;
                    case"遲到":
                      this.play_circle("打卡遲到 下次要準時哦","#eed435","black");
                      //this.play_info("打卡遲到 下次要準時哦")
                      this.anLoading = false;
                      this.anCheck = true;
                      //who.checkMsg=when+str_time;
                      //who.color="green";
                      this.getRecord();
                    break;
                    case"早退":
                      this.play_circle("打卡早退 請記得請假哦","#ee9520","white");
                      //this.play_info("打卡早退 請記得請假哦")
                      this.anLoading = false;
                      this.anCheck = true;
                      //who.checkMsg=when+str_time;
                      //who.color="green";
                      this.getRecord();
                    break;
                    case"曠職":
                      this.play_info("曠職 請記得請假哦")
                      this.anLoading = false;
                      this.anCheck = true;
                      //who.checkMsg=when+str_time;
                      //who.color="green";
                      this.getRecord();
                    break;
                    default:
                      this.play_circle("打卡成功","#51a600","white");
                      //this.play_info("打卡成功")
                      this.anLoading = false;
                      this.anCheck = true;
                      //who.checkMsg=when+str_time;
                      //who.color="green";
                      this.getRecord();
                    break;
                  }
                  // if(data.status == "無效"){
                  //   this.play_info("打卡無效 <br/>原因:沒有匹配的班表")
                  //   this.anLoading = false;
                  //   this.anCheck = true;
                  //   who.checkMsg="非"+ when +"打卡時段";
                  //   who.color="orange";
                  // }else{
                  //   this.play_info("打卡成功")
                  //   this.anLoading = false;
                  //   this.anCheck = true;
                  //   //who.checkMsg=when+str_time;
                  //   //who.color="green";
                  //   this.getRecord();
                  // }
                  
              }
            })
            .catch(function (error) { // 请求失败处理
              console.log(error);
            });
        }catch(e){
          this.msg = e;
        }
        
      },
      getAllOverTime(){
        //https://testlinepunch.pokerfun.com.tw/api/LineChat/LineUserInfo?userid=U795c83c87df0b7da1fcf0e58c3e0da7c
        try{
            axios
            //.get(this.baseURL+'/api/Punch/'+ event +'?str_GroupId='+ this.str_groupid +'&dou_Longitude='+ this.position.lng +'&dou_Latitude='+ this.position.lat +'&strUserLineID='+this.str_userid+'&shiftfId=7')
            .get(this.baseURL+'/api/OverTimeShiftTable/R_overtimeShiftTable?mid='+this.UserfId)
            .then((response) => {
              let data  = JSON.parse(response.data);
              //console.log("加班",data);
              this.ls_allovertime = data;
            })
            .catch(function (error) { // 请求失败处理
              console.log(error);
            });
        }catch(e){
          this.msg = e;
        }
      },
      getAllShift(){
        //https://testlinepunch.pokerfun.com.tw/api/LineChat/LineUserInfo?userid=U795c83c87df0b7da1fcf0e58c3e0da7c
        try{
            axios
            //.get(this.baseURL+'/api/Punch/'+ event +'?str_GroupId='+ this.str_groupid +'&dou_Longitude='+ this.position.lng +'&dou_Latitude='+ this.position.lat +'&strUserLineID='+this.str_userid+'&shiftfId=7')
            .get(this.baseURL+'/api/ShiftTable/ShiftGet?fid='+this.UserfId+'&fStatus=1')
            .then((response) => {
              let data  = JSON.parse(response.data);
              //console.log("班表",data);
              this.ls_allshift = data;
            })
            .catch(function (error) { // 请求失败处理
              console.log(error);
            });
        }catch(e){
          this.msg = e;
        }
      },
      getInfo(){
        //https://testlinepunch.pokerfun.com.tw/api/LineChat/LineUserInfo?userid=U795c83c87df0b7da1fcf0e58c3e0da7c
        try{
            axios
            //.get(this.baseURL+'/api/Punch/'+ event +'?str_GroupId='+ this.str_groupid +'&dou_Longitude='+ this.position.lng +'&dou_Latitude='+ this.position.lat +'&strUserLineID='+this.str_userid+'&shiftfId=7')
            .get(this.baseLINE+'/api/LineChat/LineUserInfo?userid='+this.str_userid)
            .then((response) => {
              
              let data = JSON.parse(response.data);
              //console.log("hello",data);
              this.User = data
              this.hello = ("您好! "+this.User.displayName);
              this.play_circle("按下按鈕開始打卡","","black");
            })
            .catch(function (error) { // 请求失败处理
              console.log(error);
            });
        }catch(e){
          this.msg = e;
        }
      },
      getRecord(){
        
        try{
          //console.log(this.baseURL+'/api/Punch/PunchHistory?LinegroupId='+ this.str_groupid +'&LineUserId='+this.str_userid)
            axios
            .get(this.baseURL+'/api/Punch/PunchHistory?LinegroupId='+ this.str_groupid +'&LineUserId='+this.str_userid)
            .then((response) => {
              this.haveRecord=true;
              let data = JSON.parse(response.data);
              ////console.log("出2151",data);
              for(let i in data){
                
                data[i].fPunchData =JSON.parse(data[i].fPunchData);
                ////console.log(data[i].fPunchData.time);
                data[i]["打卡日期"] = new Date(data[i].fPunchData.time)
                ////console.log("出",data[i].打卡日期);
              }
              //console.log("紀錄取得",data)
              let _in = Object.values(data).filter(d => d.fPunchStatus === 0 && d.fshiftfId === this.punchShift.fId && d.fGetworkStatus!="無效"  && d.打卡日期.getFullYear() == this.NowDate.getFullYear() && d.打卡日期.getMonth() == this.NowDate.getMonth()&& d.打卡日期.getDate() == this.NowDate.getDate());
              let _out = Object.values(data).filter(d => d.fPunchStatus === 1 && d.fshiftfId === this.punchShift.fId && d.fGetworkStatus!="無效" && d.打卡日期.getFullYear() == this.NowDate.getFullYear() && d.打卡日期.getMonth() == this.NowDate.getMonth()&& d.打卡日期.getDate() == this.NowDate.getDate());
              console.log("上班",_in)
              console.log("下班",_out)
              if(_in.length!=0){
                let _time = new Date(_in[0].fWriteDate);
                let str_time = this.addz(_time.getHours())+":"+this.addz(_time.getMinutes())+":"+this.addz(_time.getSeconds())
                this.btnOn.checkMsg="上班";
                this.btnOn.checkTime = str_time;
                this.btnOn.color="green";
                this.btnOn.disabled = true;//看之後要拔掉嗎
              }else{
                this.btnOn.disabled = false;
              }
              if(_out.length!=0){
                let _time = new Date(_out[_out.length-1].fWriteDate);
                let str_time = this.addz(_time.getHours())+":"+this.addz(_time.getMinutes())+":"+this.addz(_time.getSeconds())
                this.btnOff.checkMsg="下班";
                this.btnOff.checkTime = str_time;
                this.btnOff.color="green";
                this.btnOff.disabled = true;//看之後要拔掉嗎
              }else{
                this.btnOff.disabled = false;
              }
              //console.log(this.btnOn,this.btnOff); 
              // for(let d in data){
              //   //console.log(JSON.parse(data[d].fPunchData));
              // }
            })
            .catch(function (error) { // 请求失败处理
              console.log(error);
            });
        }catch(e){
          this.msg = e;
        }
      },
      getWifi(){
        axios
        .get('https://api.ipify.org?format=json')
        .then((response)=>{
          this.play_info("實際IP:"  +  response.data.ip);
        })
        .catch(function (error) { // 请求失败处理
          console.log(error);
        });
      },
    }
  }
  </script>
  <style>
    #ani_card{
      position: absolute;
      left: 0;
      right:0;
      top:-34vw;
      margin: auto;
      width: 72vw;
      height:50vh;

      background-size: contain;z-index: 5;
      transition: 0.6s;
    }
    .a-ctive{
      top: -30vw !important;
    }
    
    .circle{
      padding: 1% 5%;
      border-radius: 100px;
      border: 2px solid black;
      letter-spacing:10px;
    }
    .text-circle{
      padding: 1% 5%;
    }
    .fz-30{
      font-size: 3em;
    }
    .fz-25{
      font-size: 2.5em;
    }
    .fz-20{
      font-size: 2em;
    }
    .fz-19{
      font-size: 1.9em;
    }
    .fz-18{
      font-size: 1.8em;
    }
    .fz-17{
      font-size: 1.7em;
    }
    .fz-16{
      font-size: 1.6em;
    }
    .fz-15{
      font-size: 1.5em;
    }
    .fz-14{
      font-size: 1.4em;
    }
    .fz-13{
      font-size: 1.3em;
    }
    .fz-12{
      font-size: 1.2em;
    }
    .fz-11{
      font-size: 1.1em;
    }
    .fz-10{
      font-size: 1.0em;
    }
    .fz-9{
      font-size: 0.9em;
    }
    .fz-8{
      font-size: 0.9em;
    }
    .fz-7{
      font-size: 0.7em;
    }
    .font-bold{
      font-weight: bolder;
    }
    .text-shadow{
      /* text-shadow: 0.05em 0.05em 0.08em gray */
      text-shadow: -2px -2px white, 1px 1px #333
    }
    .text-blue-shadow{
      text-shadow: 0.05em 0.05em 0.08em #33347F;
    }
    .text-green-shadow{
      text-shadow: 0.05em 0.05em 0.08em #17A86C;
    }
    .position-center{
      position:absolute;
      margin: auto;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
    }
    @keyframes ldio-b9l1nbrfq3f-r {
              0%, 100% { animation-timing-function: cubic-bezier(0.2 0 0.8 0.8) }
              50% { animation-timing-function: cubic-bezier(0.2 0.2 0.8 1) }
              0% { transform: rotate(0deg) }
              50% { transform: rotate(180deg) }
              100% { transform: rotate(360deg) }
            }
            @keyframes ldio-b9l1nbrfq3f-s {
              0%, 100% { animation-timing-function: cubic-bezier(0.2 0 0.8 0.8) }
              50% { animation-timing-function: cubic-bezier(0.2 0.2 0.8 1) }
              0% { transform: translate(-23px,-23px) scale(0) }
              50% { transform: translate(-23px,-23px) scale(1) }
              100% { transform: translate(-23px,-23px) scale(0) }
            }
            .ldio-b9l1nbrfq3f > div { transform: translate(0px,-11.5px) }
            .ldio-b9l1nbrfq3f > div > div {
              animation: ldio-b9l1nbrfq3f-r 0.9433962264150942s linear infinite;
              transform-origin: 50px 50px;
            }
            .ldio-b9l1nbrfq3f > div > div > div {
              position: absolute;
              transform: translate(50px, 36.2px);
            }
            .ldio-b9l1nbrfq3f > div > div > div > div {
              width: 46px;
              height: 46px;
              border-radius: 50%;
              background: #292664;
              animation: ldio-b9l1nbrfq3f-s 0.9433962264150942s linear infinite;
            }
            .ldio-b9l1nbrfq3f > div > div:last-child {
              animation-delay: -0.4716981132075471s;
            }
            .ldio-b9l1nbrfq3f > div > div:last-child > div > div {
              animation-delay: -0.4716981132075471s;
              background: #667395;
            }
            .loadingio-spinner-interwind-5640uckn58s {
              width: 80px;
              height: 80px;
              display: inline-block;
              overflow: hidden;
            }
            .ldio-b9l1nbrfq3f {
              width: 100%;
              height: 100%;
              position: relative;
              transform: translateZ(0) scale(0.8);
              backface-visibility: hidden;
              transform-origin: 0 0; /* see note above */
            }
            .ldio-b9l1nbrfq3f div { box-sizing: content-box; }
            /* generated by https://loading.io/ */
            .error-banmark {
              width: 80px;
              height: 115px;
              margin: 0 auto;
            }
            .error-banmark .ban-icon {
              width: 80px;
              height: 80px;
              position: relative;
              border-radius: 50%;
              box-sizing: content-box;
              border: 4px solid #af4c4c;
            }
            .error-banmark .ban-icon::before {
              top: 3px;
              left: -2px;
              width: 30px;
              transform-origin: 100% 50%;
              border-radius: 100px 0 0 100px;
            }
            .error-banmark .ban-icon::after {
              top: 0;
              left: 40px;
              width: 60px;
              transform-origin: 0 50%;
              border-radius: 0 100px 100px 0;
              animation: rotate-circle 4.25s ease-in;
            }
            .error-banmark .ban-icon::before, .error-banmark .ban-icon::after {
              content: "";
              height: 100px;
              position: absolute;
              background: rgba(255, 255, 255, 0);
              transform: rotate(-45deg);
            }
            .error-banmark .ban-icon .icon-line {
              height: 5px;
              background-color: #af4c4c;
              display: block;
              border-radius: 2px;
              position: absolute;
              z-index: 10;
            }
            .error-banmark .ban-icon .icon-line.line-long-invert {
              top: 39px;
              left: 8px;
              width: 60px;
              transform: rotate(45deg);
              animation: icon-line-long 0.75s;
            }
            .error-banmark .ban-icon .icon-line.line-long {
              top: 39px;
              left: 8px;
              width: 60px;
              transform: rotate(-45deg);
              animation: icon-line-long 0.85s;
            }
            .error-banmark .ban-icon .icon-circle {
              top: -4px;
              left: -4px;
              z-index: 10;
              width: 80px;
              height: 80px;
              border-radius: 50%;
              position: absolute;
              box-sizing: content-box;
              border: 4px solid rgba(175, 76, 76, 0.5);
            }
            .error-banmark .ban-icon .icon-fix {
              top: 8px;
              width: 5px;
              left: 26px;
              z-index: 1;
              height: 85px;
              position: absolute;
              transform: rotate(-45deg);
              background-color: rgba(255, 255, 255, 0);
            }
            .success-checkmark {
              width: 80px;
              height: 115px;
              margin: 0 auto;
            }
            .success-checkmark .check-icon {
              width: 80px;
              height: 80px;
              position: relative;
              border-radius: 50%;
              box-sizing: content-box;
              border: 4px solid #4CAF50;
            }
            .success-checkmark .check-icon::before {
              top: 3px;
              left: -2px;
              width: 30px;
              transform-origin: 100% 50%;
              border-radius: 100px 0 0 100px;
            }
            .success-checkmark .check-icon::after {
              top: 0;
              left: 30px;
              width: 60px;
              transform-origin: 0 50%;
              border-radius: 0 100px 100px 0;
              animation: rotate-circle 4.25s ease-in;
            }
            .success-checkmark .check-icon::before, .success-checkmark .check-icon::after {
              content: "";
              height: 100px;
              position: absolute;
              background: transparent;
              transform: rotate(-45deg);
            }
            .success-checkmark .check-icon .icon-line {
              height: 5px;
              background-color: #4CAF50;
              display: block;
              border-radius: 2px;
              position: absolute;
              z-index: 10;
            }
            .success-checkmark .check-icon .icon-line.line-tip {
              top: 46px;
              left: 14px;
              width: 25px;
              transform: rotate(45deg);
              animation: icon-line-tip 0.75s;
            }
            .success-checkmark .check-icon .icon-line.line-long {
              top: 38px;
              right: 8px;
              width: 47px;
              transform: rotate(-45deg);
              animation: icon-line-long 0.75s;
            }
            .success-checkmark .check-icon .icon-circle {
              top: -4px;
              left: -4px;
              z-index: 10;
              width: 80px;
              height: 80px;
              border-radius: 50%;
              position: absolute;
              box-sizing: content-box;
              border: 4px solid rgba(76, 175, 80, 0.5);
            }
            .success-checkmark .check-icon .icon-fix {
              top: 8px;
              width: 5px;
              left: 26px;
              z-index: 1;
              height: 85px;
              position: absolute;
              transform: rotate(-45deg);
              background-color: transparent;
            }

            @keyframes rotate-circle {
              0% {
                transform: rotate(-45deg);
              }
              5% {
                transform: rotate(-45deg);
              }
              12% {
                transform: rotate(-405deg);
              }
              100% {
                transform: rotate(-405deg);
              }
            }
            @keyframes icon-line-tip {
              0% {
                width: 0;
                left: 1px;
                top: 19px;
              }
              54% {
                width: 0;
                left: 1px;
                top: 19px;
              }
              70% {
                width: 50px;
                left: -8px;
                top: 37px;
              }
              84% {
                width: 17px;
                left: 21px;
                top: 48px;
              }
              100% {
                width: 25px;
                left: 14px;
                top: 45px;
              }
            }
            @keyframes icon-line-long {
              0% {
                width: 0;
                right: 46px;
                top: 54px;
              }
              65% {
                width: 0;
                right: 46px;
                top: 54px;
              }
              84% {
                width: 55px;
                right: 0px;
                top: 35px;
              }
              100% {
                width: 47px;
                right: 8px;
                top: 38px;
              }
            }
  </style>
